<template>
    <b-container fluid class="animated fadeIn">
        <h1>Incluir / Alterar Petição</h1>
        <b-card>
            <b-row>
                <b-col xs="12" sm="12" md="8" lg="8" xl="8">
                    <b-form-group label="Nome do Autor: *" label-for="nomeAutor" class="text-label">
                        <b-form-input 
                            name="nomeAutor"
                            v-model="peticao.nomeAutor" 
                            type="text" 
                            maxlength="150"
                            v-validate="{ required: true }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Tipo de Crédito: *" label-for="tipoCredito" class="text-label">
                        <multiselect
                            name="tipoCredito"
                            v-model="peticao.tipoCredito"
                            :show-labels="false"
                            :options="dados.tiposCredito"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="true"
                            :preserve-search="false"
                            placeholder="Selecione"
                            track-by="id"
                            label="nome"
                            v-validate="{ required: true }"
                        >
                        </multiselect>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="CNPJ: *" label-for="cnpjAutor" class="text-label">
                        <b-form-input 
                            name="cnpjAutor"
                            v-model="peticao.cnpjAutor" 
                            type="text" 
                            maxlength="18"
                            v-mask="'XX.XXX.XXX/XXXX-##'"
                            v-validate="{ required: true, min: 18 }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="8" lg="8" xl="8">
                    <div class="form-group text-label">
                        <label for="textoPadrao" class="d-block">Texto Padrão: * 
                            <i  id="infoTextoPadrao" style="color: #007bff" class="fa fa-info-circle fa-lg pl-2" />
                        </label>
                        <b-tooltip target="infoTextoPadrao" variant="secondary" placement="rightbottom">
                            <strong>Tags</strong>
                            <hr class="p-0 m-0 pb-1 mt-1">
                            <div class="justify-content-between" style="text-align: left">
                                <p class="p-0 m-0" v-for="dados in dados.tags" :key="dados.id">
                                    {{ dados.id }} - {{ dados.nome }}
                                </p>
                            </div>
                        </b-tooltip>
                        <b-form-textarea
                            id="textoPadrao"
                            name="textoPadrao"
                            v-model="peticao.textoPadrao"
                            rows="10"
                            max-rows="10"
                         
                        ></b-form-textarea>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="8" lg="8" xl="8">
                    <b-form-group label="CEP:" label-for="cepAutor" class="text-label">
                        <b-form inline>
                            <b-form-input 
                                name="cepAutor"
                                v-model="peticao.cepAutor" 
                                type="text" 
                                maxlength="9"
                                v-mask="['#####-###']"
                                v-validate="{ min: 9 }"
                                @keyup="buscarCep()"
                                :disabled="inSearchCEP" />
                                <b-spinner class="ml-3" v-show="inSearchCEP" small label="Buscando cep..." type="grow"></b-spinner>
                        </b-form>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="8" lg="8" xl="8">
                    <b-form-group label="Endereço do Autor: *" label-for="enderecoAutor" class="text-label">
                        <b-form-input 
                            name="enderecoAutor"
                            v-model="peticao.enderecoAutor" 
                            type="text" 
                            maxlength="150"
                            v-validate="{ required: true }" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Complemento:" label-for="complementoAutor" class="text-label">
                        <b-form-input 
                            name="complementoAutor"
                            v-model="peticao.complementoAutor" 
                            type="text" 
                            maxlength="100" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Bairro:" label-for="bairroAutor" class="text-label">
                        <b-form-input 
                            name="bairroAutor"
                            v-model="peticao.bairroAutor" 
                            type="text" 
                            maxlength="50" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Município:" label-for="municipio" class="text-label">
                        <multiselect
                            name="municipio"
                            v-model="peticao.municipio"
                            :show-labels="false"
                            :options="dados.municipios"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="true"
                            :preserve-search="false"
                            placeholder="Selecione"
                            track-by="codMunicipio"
                            label="nome"
                        >
                        </multiselect>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="8" sm="8" md="8" lg="8" xl="8">
                    <b-tabs content-class="mt-3" fill>
                        <b-tab title="Tipos de Texto" active>
                            <b-row>
                                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                                    <b-form-group label="Tipo de Texto: *" label-for="tipoTextoPeticao" class="text-label">
                                        <multiselect
                                            name="tipoTextoPeticao"
                                            v-model="tipoTexto.tipoTextoPeticao"
                                            :show-labels="false"
                                            :options="dados.tiposTexto"
                                            :multiple="false"
                                            :close-on-select="true"
                                            :clear-on-select="true"
                                            :preserve-search="false"
                                            placeholder="Selecione"
                                            track-by="id"
                                            label="nome"
                                        >
                                        </multiselect>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                    <div class="form-group text-label">
                                        <label for="textoPadrao" class="d-block">Texto: * 
                                            <i  id="infoTexto" style="color: #007bff" class="fa fa-info-circle fa-lg pl-2" />
                                        </label>
                                        <b-tooltip target="infoTexto" variant="secondary" placement="rightbottom">
                                            <strong>Tags</strong>
                                            <hr class="p-0 m-0 pb-1 mt-1">
                                            <div class="justify-content-between" style="text-align: left">
                                                <p class="p-0 m-0" v-for="dados in dados.tags" :key="dados.id">
                                                    {{ dados.id }} - {{ dados.nome }}
                                                </p>
                                            </div>
                                        </b-tooltip>
                                        <b-form-textarea
                                            name="textoPeticao"
                                            v-model="tipoTexto.textoPeticao"
                                            rows="10"
                                            max-rows="10"
                                        ></b-form-textarea>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                    <b-form-group label="Notação:" label-for="notacao" class="text-label">
                                        <b-form-textarea
                                            name="notacao"
                                            v-model="tipoTexto.notacao"
                                            rows="5"
                                            max-rows="5"
                                        ></b-form-textarea>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col xs="12" sm="12" md="12" lg="12" xl="12" class="text-center">
                                    <b-button variant="primary" class="fonte-branca ml-1" @click.prevent="adicionarTipoTexto">
                                        <i class="fa fa-plus"></i> Adicionar
                                    </b-button>
                                </b-col>
                            </b-row>
                            <b-row class="d-flex justify-content-between">
                                <b-col></b-col>
                                <b-col>
                                    <div>
                                        <b-pagination v-model="configTableTipoTexto.currentPage" :per-page="configTableTipoTexto.perPage" :total-rows="configTableTipoTexto.rows" size="sm" class="pl-3" style="float:right" v-if="configTableTipoTexto.perPage != 'Todos'">
                                        </b-pagination>
                                        <b-form-select v-model="configTableTipoTexto.perPage" :options="[100, 500, 1000, 'Todos']" size="sm" class="mb-3 col-3" style="float:right"></b-form-select>
                                    </div>
                                </b-col>
                            </b-row>
                            <TabelaTipoTexto
                                :dados="peticao.listaTextoTipoPeticao"
                                :fields="fieldsTipoTexto"
                                @excluir="excluirTipoTexto"
                                :configTable="configTableTipoTexto" />
                            <b-row class="d-flex justify-content-between">
                                <b-col></b-col>
                                <b-col>
                                    <div>
                                        <div>
                                            <b-pagination v-model="configTableTipoTexto.currentPage" :per-page="configTableTipoTexto.perPage" :total-rows="configTableTipoTexto.rows" size="sm" class="pl-3" style="float:right" v-if="configTableTipoTexto.perPage != 'Todos'">
                                            </b-pagination>
                                            <b-form-select v-model="configTableTipoTexto.perPage" :options="[100, 500, 1000, 'Todos']" size="sm" class="mb-3 col-3" style="float:right"></b-form-select>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
             <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group
                        id="groupAtivo"
                        label="Situação: *"
                        label-for="ativo">
                        <b-form-checkbox switch v-model="peticao.indAtivo">{{ peticao.indAtivo ? 'Ativo' : 'Inativo'}}</b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-button variant="primary" @click.prevent="salvar" :disabled="inSave">
                        <i class="fa fa-save"></i> Salvar
                    </b-button>
                    <b-button variant="primary" class="ml-2" @click="voltar">
                        <i class="fa fa-reply"></i> Voltar
                    </b-button>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import TabelaTipoTexto from './TabelaTipoTexto'

export default {
    name: 'ManterPeticaoEditar',
    components: {
        TabelaTipoTexto
    },
    data() {
        return {
            inSearchCEP: false,
            inSave: false,
            tipoTexto: {
                codTextoTipoPeticao: null,
                tipoTextoPeticao: null,
                textoPeticao: null,
                notacao: null
            },
            peticao: {
                codTipoPeticao: null,
                nomeAutor: null,
                tipoCredito: null,
                cnpjAutor: null,
                textoPadrao: null,
                cepAutor: null,
                enderecoAutor: null,
                complementoAutor: null,
                bairroAutor: null,
                municipio: null,
                indAtivo: true,
                listaTextoTipoPeticao: []
            },
            dados: {
                municipios: [],
                tiposCredito: [],
                tiposTexto: [],
                tags: []
            },
            configTableTipoTexto: {
                perPage: 100,
                currentPage: 1,
                rows: 0,
                msgEmpty: 'Nenhum Tipo de Texto encontrado.'
            },
            fieldsTipoTexto: [
                {
                    key: 'tipoTextoPeticao.nome',
                    label: 'Tipo de Texto',
                    class: 'text-center'
                },
                {
                    key: 'textoPeticao',
                    label: 'Texto'
                },
                {
                    key: 'notacao',
                    label: 'Notação'
                },
                {
                    key: 'excluir',
                    label: 'Excluir',
                    class: 'text-center'
                }
            ],
        }
    },
    watch: {
        getTiposTexto() {
            this.atualizarTabelas()
        },
    },
    computed: {
        getTiposTexto() {
            return this.peticao.listaTextoTipoPeticao
        },
    },
    methods: {

        salvar() {
            this.inSave = true
            this.$validator.validateAll().then( async (result) => {
                if (!result) {
                    this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: ['Favor preencher os campos obrigatórios (*)'] });
                    this.inSave = false
                    window.scrollTo(0,0);
                    return
                }

                const urlApi = process.env.VUE_APP_ROOT_API
                const token = JSON.parse(this.$store.getters.getUser).access_token

                const peticao = {
                    ...this.peticao
                }

                await axios.post(`${urlApi}/v1/peticao/salvar`, peticao, {
                    headers: {
                        'Authorization': token,
                        'Content-Type': 'application/json',
                    }
                })
                .then(response => {
                    if(response.data) {
                        this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: [`${response.data.message}`] });
                        window.scrollTo(0,0);
                        return
                    }
                    this.$store.commit("setMsgPeticao", 'Operação realizada com sucesso!!!')
                    this.$store.commit("setPeticao", null);
                    this.$router.push({ path: '/peticao' })
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.inSave = false
                })
            })
        },

        voltar() {
            this.$store.commit("setPeticao", null);
            this.$router.push({ path: '/peticao' })
        },

        adicionarTipoTexto() {
            const valido = this.validarParametrosTipoTexto(this.tipoTexto)

            if(!valido) {
                let msg = []
                if(!this.tipoTexto.tipoTextoPeticao) msg.push('O campo Tipo de Texto deve ser informado.')
                if(!this.tipoTexto.textoPeticao) msg.push('O campo Texto deve ser informado.')
                this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: msg });
                window.scrollTo(0,0);
                return
            }
            if(this.tipoTexto) {
                const existentes = this.peticao.listaTextoTipoPeticao.filter(tt => tt.tipoTextoPeticao.id === this.tipoTexto.tipoTextoPeticao.id)
                if(existentes.length) {
                    this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: ['Já existe um texto com este tipo de texto adicionado.'] });
                    window.scrollTo(0,0);
                    return
                } else {
                    const { tipoTextoPeticao, textoPeticao, notacao } = this.tipoTexto
                    this.peticao.listaTextoTipoPeticao.push({ tipoTextoPeticao, textoPeticao, notacao })
                }
            }

            this.tipoTexto = {
                codTextoTipoPeticao: null,
                tipoTextoPeticao: null,
                textoPeticao: null,
                notacao: null
            }
        },

        validarParametrosTipoTexto(tipoTexto) {
            let valido = true
            if(tipoTexto) {
                if(!tipoTexto.tipoTextoPeticao) valido = false
                if(!tipoTexto.textoPeticao) valido = false
            } else {
                valido = false
            }
            return valido
        },

        atualizarTabelas() {
            this.configTableTipoTexto.rows = this.peticao.listaTextoTipoPeticao.length
        },

        excluirTipoTexto(item) {
            if(item) {
                const index = this.peticao.listaTextoTipoPeticao.indexOf(item)
                this.peticao.listaTextoTipoPeticao.splice(index, 1)
            }
        },

        async buscarCep() {
            if(this.peticao.cepAutor) {
                if(this.peticao.cepAutor.toString().length === 9) {
                    this.inSearchCEP = true

                    const urlApi = process.env.VUE_APP_ROOT_API
                    const token = JSON.parse(this.$store.getters.getUser).access_token
                    const cepNumeros = this.onlyNumber(this.peticao.cepAutor)

                    axios.get(`${urlApi}/neocep/enderecamento/v3/endereco/${cepNumeros}/${2}`, {}, {
                        headers: {
                            'Authorization': token,
                            'Content-Type': 'application/json',
                        }
                    })
                    .then(response => {
                        this.peticao.enderecoAutor = response.data.endereco;
                        this.peticao.complementoAutor = response.data.complemento
                        this.peticao.bairroAutor = response.data.bairro
                    }).finally(() => {
                        this.inSearchCEP = false
                    })
                }
            }
        },

        onlyNumber(string) 
        {
            var numsStr = string.replace(/[^0-9]/g,'');
            return parseInt(numsStr);
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Listar municípios
         */
        async listarMunicipios() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/municipio/listarPR`)
            .then(response => {
              this.dados.municipios = response.data
            })
        },

        /**
         * Listar tipos de crédito
         */
        async listarTipoCredito() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/peticao/listarTipoCredito`)
            .then(response => {
              this.dados.tiposCredito = response.data
            })
        },

        /**
         * Listar tipos de textos
         */
        async listarTipoTexto() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/peticao/listarTipoTexto`)
            .then(response => {
              this.dados.tiposTexto = response.data
            })
        },

        /**
         * Listar tags de textos
         */
        async listarTags() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/peticao/listarTagsTexto`)
            .then(response => {
              this.dados.tags = response.data
            })
        },

        async obterPeticao(codTipoPeticao) {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            await axios.post(`${urlApi}/v1/peticao/obter`, codTipoPeticao, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
                this.peticao = response.data
            }).catch((error) => {
                this.exibirErro(error)
            })
        },
    },
    mounted() {
        this.$store.commit("setMessages", {});

        const peticaoEditada = this.$store.getters.getPeticao;
        if(peticaoEditada) {
            this.obterPeticao(peticaoEditada.codTipoPeticao)
        }

        this.listarMunicipios()
        this.listarTipoCredito()
        this.listarTipoTexto()
        this.listarTags()
        this.atualizarTabelas()

    }
    
}
</script>

<style scoped>

</style>